import { Match } from "effect"
import type { UiUnlock } from "../../UiUnlock.ts"
import { AppUnlock } from "./AppUnlock.tsx"
import { ContentUnlock } from "./ContentUnlock.tsx"

type UnlockedUnlockProps = {
  unlock: UiUnlock.Unlocked
  locale: string
  priority?: boolean
}

export const UnlockedUnlock = ({ unlock, locale, priority = false }: UnlockedUnlockProps) => {
  return Match.valueTags(unlock.value, {
    Content: (content) => <ContentUnlock.Unlocked content={content} locale={locale} priority={priority} />,
    App: (app) => <AppUnlock.Unlocked content={app} locale={locale} />
  })
}
